/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
export interface IOptionGroup {
  isEnabled: boolean;
}

export class ConfigurationMenuGroup implements IOptionGroup {
  public manageUsers = false;
  public accessDatabaseAudit = false;

  public get isEnabled(): boolean {
    return (
      this.manageUsers ||
      this.accessDatabaseAudit
    );
  }
}

export class SystemMenuGroup implements IOptionGroup {
  public accessDatabaseAudit = false;
  public submitDefect = false;

  public get isEnabled(): boolean {
    return (
      this.submitDefect ||
      this.accessDatabaseAudit
    );
  }
}

export class HeaderMenu implements IOptionGroup {
  public showKioskLink = false;
  public showResetPassword = false;

  public get isEnabled(): boolean {
    return this.showKioskLink;
  }
}

export class MenuPermissions implements IOptionGroup {
  available = false;

  public get isEnabled(): boolean {
    return this.available;
  }
}

export class ActionOptions {
  public menu = new MenuPermissions();
  public configurationMenu = new ConfigurationMenuGroup();
  public systemMenu = new SystemMenuGroup();
  public headerMenu = new HeaderMenu();
}

export class UserPermissions {
  public isInitialised = false;
  public userName = '';
  public action = new ActionOptions();

  public isSuperUser: boolean;
  public isOrganiserUser: boolean;
  public isCustomerServicesUser: boolean;
  public isAccountManager: boolean;
  public isInternalOrbitUser: boolean;

  public markAsInitialised(userName: string) {
    this.isInitialised = true;
    this.userName = userName;
  }
}

export class UserPermissionsAction {
  public message: string;

  constructor(message: string) {
    this.message = message;
  }
}
